module.exports = __webpack_public_path__ + "media/icons/edit-pen-ec5fc271.svg";